export default __webpack_public_path__ + "static/media/truck.48451325.svg";